import {
	confluenceLocalStorageInstance as localStorage,
	keys as localStorageKeys,
} from '@confluence/storage-manager';

const MAX_DISMISSAL_COUNT = 1;

const EXPIRY_IN_ONE_DAY = 60 * 60 * 24 * 1;

export const isFeatureVisited = (): boolean => {
	try {
		if (getFeatureVisited()) {
			return true;
		}
		setFeatureVisited();
		if (!getFeatureVisited()) {
			return true;
		}
		return false;
	} catch (error: any) {
		return true;
	}
};

const setFeatureVisited = () => {
	localStorage.setItem(
		localStorageKeys.INVITE_ON_PAGE_PUBLISH_VISITED_KEY,
		true,
		EXPIRY_IN_ONE_DAY,
	);
};

const getFeatureVisited = (): boolean =>
	localStorage.getItemAsBoolean(localStorageKeys.INVITE_ON_PAGE_PUBLISH_VISITED_KEY);

export const shouldShowOptOutOption = (): boolean => {
	const dismissalCount = getDismissalCount();
	return dismissalCount >= MAX_DISMISSAL_COUNT;
};

export const getDismissalCount = (): number => {
	const value = localStorage.getItem(localStorageKeys.INVITE_ON_PAGE_PUBLISH_DISMISSAL_COUNT);
	return parseInt(value, 10) || 0;
};

export const increaseDismissalCount = () => {
	const currentCount = getDismissalCount();
	localStorage.setItem(localStorageKeys.INVITE_ON_PAGE_PUBLISH_DISMISSAL_COUNT, currentCount + 1);
};

export const setUserOptedOut = () => {
	localStorage.setItem(localStorageKeys.INVITE_ON_PAGE_PUBLISH_OPT_OUT, true);
};

export const isUserOptedOut = () =>
	localStorage.getItemAsBoolean(localStorageKeys.INVITE_ON_PAGE_PUBLISH_OPT_OUT);
